let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ljL6x")).then(() => parcelRequire('4MX1d'));